import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import REFINANCEIRQHowMuchCashOutView from "../views/REFINANCEIRQHowMuchCashOutView";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { withDataMapping } from "../util/hocs/withDataMapping";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { getDownPaymentMinimum } from "../util/getDownPaymentMinimum";
import { number, object } from "yup";
import { LoadingIndicator } from "../atoms/LoadingIndicator";
import StatusCheck from "../components/StatusCheck";
import { CountyLimitsContext } from "../context/CountyLimitsContext";

class RefinanceIrqHowMuchCashOutPage extends Component {
  static contextType = CountyLimitsContext;

  componentDidMount() {
    this.context.fetchCountyLimits();
  }

  render() {
    const { data } = this.props;
    const { countyLimits } = this.context;
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    const firstTimeBuyer = localStorage.getItem("firstTimeBuyer");
    const minDownPaymentPercent = getDownPaymentMinimum({
      countyLimits,
      county: data.county,
      state: data.state,
      countyFips: data.countyFips,
      stateFips: data.stateFips,
      loanAmount: data.price,
      propertyType: data.propertyType,
      occupancyType: data.occupancyType,
      lookingTo: "Cashout",
      isFirstTimeHomebuyer: firstTimeBuyer === null ? "false" : firstTimeBuyer,
    });

    const maxCashOut =
      data.price -
      data.price * (minDownPaymentPercent / 100) -
      data.existingLoanBalance;

    if (countyLimits === null) {
      return (
        <div className="page-wrapper">
          <LoadingIndicator label="Fetching page data..." />
        </div>
      );
    }

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="refinanceIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object().shape({
            amountOfCashOut: number()
              .integer()
              .positive()
              .max(
                maxCashOut,
                "You must exceed the minimum loan to value ratio required."
              )
              .required(),
          })}
        >
          <REFINANCEIRQHowMuchCashOutView
            content={contentMap.RefinanceIrqHowMuchCashOutPage}
            navigationsAway={customNavigationMap.RefinanceIrqHowMuchCashOutPage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(
  withDataMapping(RefinanceIrqHowMuchCashOutPage)
);
